import React from 'react';
import PText from './PText';


export default function Map() {
  return (
    <div>
        <div className="container">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13991.571014836394!2d77.48812095465122!3d28.752618821744704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf47204fb9241%3A0xd11ed4123c7691fe!2sKIET%20GROUP%20OF%20INSTITUTIONS%2C%20Muradnagar%2C%20Uttar%20Pradesh%20201206!5e0!3m2!1sen!2sin!4v1695752589994!5m2!1sen!2sin" style = {{width:"100%", height:"550", style:"border:0;" ,allowfullscreen:"", loading:"lazy" ,referrerpolicy:"no-referrer-when-downgrade"}}></iframe>
        </div>
    </div>
  )
}
